import { FC } from "react";
import SRC from "./Lena.jpg";

export const Lena: FC = () => {
  return (
    <div className="image">
      <img src={SRC} alt="" />
      <div className="hover-info neela-style">
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        <div className="content center">
          <h3>
            Olena Hrachova<small>Bridesmaid</small>
          </h3>
          <ul className="sn-icons">
            <li>
              <a
                href="https://www.instagram.com/lena.grchv"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-instagram-square"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
